/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { IReverseGeocodingService } from './reverse-geocoding.service.interface';
import { IStatusPanelItem, IVehiclePlot, IReverseGeocodeExecutionBatch } from '../../core/models';
import { ReverseGeocodeVehiclePlots } from '../../core/store/actions';
import { IAppState } from '../../core/store/state';

@Injectable({
  providedIn: 'root'
})
export class ReverseGeocodingService implements IReverseGeocodingService {
  getMissingAddressesOfStatusPanelItems(items: IStatusPanelItem[]): void {
    const vehiclePlotsToReverseGeocode: IVehiclePlot[] = [];
    let reverseGeocodeExecutionBatch: IReverseGeocodeExecutionBatch;

    items
      .filter(item => !this._isAsset(item))
      .map(i => i as IVehiclePlot)
      .forEach(plot => {
        if (plot?.address === null && !plot.isSearchingAddress) {
          vehiclePlotsToReverseGeocode.push(plot);
        }
      });

    if (vehiclePlotsToReverseGeocode.length) {
      reverseGeocodeExecutionBatch = {
        id: Date.now(),
        vehiclePlots: vehiclePlotsToReverseGeocode
      };
      this._store.dispatch(new ReverseGeocodeVehiclePlots(reverseGeocodeExecutionBatch));
    }
  }

  constructor(private readonly _store: Store<IAppState>) {}

  private _isAsset(item: IStatusPanelItem) {
    return item.center;
  }
}
